import axiosInstance from "../Axios/axiosInstance";

const getAllNotifications = async () => {
  return await axiosInstance.get("/notifications/");
};

const getNotificationById = async (id) => {
  return await axiosInstance.get(`/notifications/${id}`);
};

const addNotification = async (data) => {
  console.log(data);
  return await axiosInstance.post("/notifications/", data);
};

const editNotification = async (id, data) => {
  return await axiosInstance.put(`/notifications/${id}`, data);
};

const deleteNotification = async (id) => {
  return await axiosInstance.delete(`/notifications/${id}`);
};

export default {
  getAllNotifications,
  getNotificationById,
  addNotification,
  editNotification,
  deleteNotification,
};
